import { useEffect, useState } from "react";
import styled from "styled-components";
import axios from "axios";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import Loader from "../components/Loader";
import AddUserModal from "../components/AddUserModal";
import FilterBar from "../components/filterBar";
import { useNavigate } from "react-router-dom";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL; // update if needed

const Page = styled.div`
  min-height: 100vh;
  background: #f6f8fb;
  font-family: 'Segoe UI', 'Inter', Arial, sans-serif;
`;

const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 24px 18px 32px;
`;

const PageTitle = styled.h2`
  font-size: 1.6rem;
  font-weight: 700;
  color: #21325b;
  margin-bottom: 18px;
  flex:8
`;

const TableCard = styled.div`
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 10px rgba(35,62,88,0.06);
  padding: 20px;
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  th, td {
    text-align: left;
    padding: 8px 12px; // reduce here
    border-bottom: 1px solid #eee;
  }
  th {
    font-weight: 600;
    color: #2b3b5f;
  }
`;

const Button = styled.button`
  background: #3772FF; // default; override via inline style if needed
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 0.5rem 0.5rem;
  min-width: 90px;    // sets all buttons to same minimum width
  height: 36px;       // fixes height for consistency
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(35,62,88,0.05);
  &:hover {
    background: #245bb9;
  }
  margin: 10px 0;
`;

 const Row = styled.div`
  display: flex;
  gap: 22px;
  margin-bottom: 0.3rem;
`;

export default function UsersPage() {
    const userData = {
    user : JSON.parse(localStorage.getItem('user')),
    token : localStorage.getItem('access_token')
  }
  const navigate = useNavigate()
  const [filterText, setFilterText] = useState('');
const [filterFromDate, setFilterFromDate] = useState(null);
const [filterToDate, setFilterToDate] = useState(null);
const [sortField, setSortField] = useState(null);
const [sortOrder, setSortOrder] = useState(null);

  const isAdmin = userData.user.roles.role_name == "SUPER_ADMIN"
const hostname = window.location.hostname;
  const isInventoryDomain = hostname === 'inventory.fescafe.in' || hostname === 'localhost';
  const isRecordsDomain = hostname === 'records.fescafe.in' ;

  const token = localStorage.getItem('access_token');
  const headers = { Authorization: `Bearer ${token}` };
  const [isLoading,setIsLoading] = useState(false);
  const [editUser, setEditUser] = useState(null);
const [isEditMode, setIsEditMode] = useState(false);
  const [allUsers,setAllUsers] = useState([])
  const [users, setUsers] = useState([]);
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);
const fetchUsers = async () => {
  setIsLoading(true)
      try {
        const res = await axios.get(`${BACKEND_URL}/user`,{headers});
        setUsers(res.data.sort((a,b)=> a.id - b.id));
                setAllUsers(res.data.sort((a,b)=> a.id - b.id));

        setIsLoading(false)
      } catch (err) {
        console.log("Error fetching users:", err.message);
                setIsLoading(false)

      }
    };
  useEffect(() => {
    if(!isAdmin)
      navigate(isRecordsDomain ?'/cashflow' : '/inventory/entries')
    fetchUsers();
  }, []);

  // Sort functions

 useEffect(() => {
  let filtered = allUsers;

  // Text filter
  if (filterText) {
    const lowerSearch = filterText.toLowerCase();
    filtered = filtered.filter(u =>
      (`${u.first_name} ${u.last_name}`).toLowerCase().includes(lowerSearch) ||
      u.username.toLowerCase().includes(lowerSearch)
    );
  }

  // Date filter on created_at
  if (filterFromDate || filterToDate) {
    filtered = filtered.filter(u => {
      const createdAt = new Date(u.created_at);
      const from = filterFromDate ? new Date(filterFromDate) : null;
      const to = filterToDate ? new Date(filterToDate) : null;
      return (!from || createdAt >= from) && (!to || createdAt <= to);
    });
  }

  // Sort
  if (sortField && sortOrder) {
    filtered = [...filtered].sort((a,b) => {
      let aVal = a[sortField];
      let bVal = b[sortField];

      if (sortField === "created_at" || sortField === "updated_at") {
        aVal = new Date(aVal);
        bVal = new Date(bVal);
      } else {
        aVal = aVal || '';
        bVal = bVal || '';
      }
      if (aVal < bVal) return sortOrder === 'asc' ? -1 : 1;
      if (aVal > bVal) return sortOrder === 'asc' ? 1 : -1;
      return 0;
    });
  }

  setUsers(filtered);
}, [allUsers, filterText, filterFromDate, filterToDate, sortField, sortOrder]);

const handleTextFilter = (text) => setFilterText(text || '');
const handleDateFilter = (from, to) => {
  setFilterFromDate(from || null);
  setFilterToDate(to || null);
};
const handleSortChange = (field, order) => {
  setSortField(field);
  setSortOrder(order);
};
const handleResetFilters = () => {
  setFilterText('');
  setFilterFromDate(null);
  setFilterToDate(null);
  setSortField(null);
  setSortOrder(null);
};


// Excel export handler
const exportToExcel = () => {
  const data = users.map(u => ({
    ID: u.id,
    Name: `${u.first_name} ${u.last_name}`,
    Username: u.username,
    Store: u.store ? `${u.store.friendly_name}, ${u.store.city}, ${u.store.state}` : "None",
    Role: u.role?.role_name || "",
    CreatedBy: `${u.created_by.first_name} ${u.created_by.last_name}`,
    CreatedOn: new Date(u.created_at).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' }),
    ModifiedBy: `${u.updated_by.first_name} ${u.updated_by.last_name}`,
    ModifiedOn: new Date(u.updated_at).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' }),
  }));

  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Users");
  XLSX.writeFile(workbook, "users_export.xlsx");
};


// PDF export handler
const exportToPDF = () => {
  const doc = new jsPDF();
  const columns = [
    { header: 'ID', dataKey: 'id' },
    { header: 'Name', dataKey: 'name' },
    { header: 'Username', dataKey: 'username' },
    { header: 'Store', dataKey: 'store' },
    { header: 'Role', dataKey: 'role' },
    { header: 'Created By', dataKey: 'createdBy' },
    { header: 'Created On', dataKey: 'createdOn' },
    { header: 'Modified By', dataKey: 'modifiedBy' },
    { header: 'Modified On', dataKey: 'modifiedOn' }
  ];

  const rows = users.map(u => ({
    id: u.id,
    name: `${u.first_name} ${u.last_name}`,
    username: u.username,
    store: u.store ? `${u.store.friendly_name}, ${u.store.city}, ${u.store.state}` : "None",
    role: u.role?.role_name || "",
    createdBy: `${u.created_by.first_name} ${u.created_by.last_name}`,
    createdOn: new Date(u.created_at).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' }),
    modifiedBy: `${u.updated_by.first_name} ${u.updated_by.last_name}`,
    modifiedOn: new Date(u.updated_at).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' }),
  }));

autoTable(doc, { columns, body: rows, margin: { top: 10 }, styles: { fontSize: 8 } });
  doc.save("users_export.pdf");
};

const handleResetPassword = async (userId) => {
  if (!window.confirm("Are you sure you want to reset this user's password to default?")) return;

  setIsLoading(true);
  try {
    await axios.post(
      `${BACKEND_URL}/auth/reset-user-password`,
      { userId },
      { headers }
    );
    alert("User password reset to default!");
  } catch (err) {
    console.error("Error resetting password:", err.message);
    alert("Failed to reset password.");
  }
  setIsLoading(false);
};


  const openEditModal = (user) => {
  setEditUser(user);
  setIsEditMode(true);
  setIsAddUserModalOpen(true);
};
const openAddModal = () => {
  setEditUser(null);
  setIsEditMode(false);
  setIsAddUserModalOpen(true);
};
// Add this handler function inside UsersPage component:
const handleDeleteUser = async (userId) => {
  if (!window.confirm("Are you sure you want to delete this user?")) return;

  setIsLoading(true);
  try {
    await axios.get(`${BACKEND_URL}/user/delete/${userId}`, { headers });
    // Refetch users after delete
    await fetchUsers();
  } catch (err) {
    console.error("Error deleting user:", err.message);
  }
  setIsLoading(false);
};

  return (
    <>
      {/* <MainHeader /> */}
      {isLoading && <Loader />}

      <Page>
        <Container>
          <Row>
            <PageTitle>Users</PageTitle>
                              {isAdmin &&  <Button onClick={openAddModal}>Add User</Button>}

          </Row>
          <Row>
            <FilterBar
             placeholder="Search Users..."
              sortFields={[
                { value: "first_name", label: "First Name" },
                { value: "last_name", label: "Last Name" },
                { value: "username", label: "Username" },
                { value: "created_at", label: "Created Date" },
                { value: "updated_at", label: "Last Modified Date" }
              ]}
              onTextFilter={handleTextFilter}
              onDateFilter={handleDateFilter}
              onSortChange={handleSortChange}
              onResetFilters={() => setUsers(allUsers)}
              onExportPDF={exportToPDF}
  onExportExcel={exportToExcel}
            ></FilterBar>
          </Row>
          

          <TableCard>
            <Table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Username</th>
                  {/* <th>Contact</th> */}
                  <th>Store</th>
                  <th>Role</th>
                  <th>Created by</th>
                  <th>Created on</th>
                  <th>Last modified by</th>
                  <th>Last modified on</th>
                  
                  
                  <th>Actions</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {users.map((u) => (
                  <tr key={u.id}>
                    <td>{u.id}</td>
                    <td>{u.first_name + ' ' + u.last_name}</td>
                    <td>{u.username}</td>
                    {/* <td>{u.contact_no}</td> */}
                    <td title={u.store ? u.store.friendly_name+","+u.store.city+","+u.store.state : "None"}>{u.store? 
                    ((u.store?.friendly_name+','+u.store?.city+','+ u.store?.state).length > 14 ?
                    (u.store?.friendly_name+','+u.store?.city+','+ u.store?.state).slice(0,26) + '...' : u.store?.friendly_name+','+u.store?.city+','+ u.store?.state)
                    
                    : "None"}</td>
                    <td>{u.role?.role_name}</td>
                    <td>{`${u.created_by.first_name} ${u.created_by.last_name}`}</td>
                    <td>{new Date(u.created_at).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}</td> 
                    <td>{`${u.updated_by.first_name} ${u.updated_by.last_name}`}</td>
                    <td>{new Date(u.updated_at).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}</td> 
                    
                    
                  { u.role?.role_name != "SUPER_ADMIN" &&   <td>
        <Button onClick={() => openEditModal(u)} disabled={!isAdmin}>Edit</Button>
      </td>}
                      { u.role?.role_name != "SUPER_ADMIN" &&   <td> <Button 
    onClick={() => handleDeleteUser(u.id)} 
    disabled={!isAdmin} 
    style={{ marginLeft: "2px", backgroundColor: "#d9534f" }}
  >
    Delete
  </Button></td>}
  <td> <Button
    title="Reset Password"
    onClick={() => handleResetPassword(u.id)}
    disabled={!isAdmin}
    style={{ backgroundColor: "#ffae42" }}
  >
    Reset 
  </Button></td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </TableCard>
           {/* Conditionally render modal */}
         {isAddUserModalOpen && (
  <AddUserModal
    isOpen={isAddUserModalOpen}
    onClose={() => {
      setIsAddUserModalOpen(false);
      setEditUser(null);
      setIsEditMode(false);
    }}
    isEdit={isEditMode}
    editUser={editUser}
    onUserAdded={fetchUsers}
    onUserUpdated={fetchUsers}
  />
)}
        </Container>
      </Page>
    </>
  );
}
